import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { defaultCompare } from "logic/DefaultCompare";
import Direction from "views/logic/aggregationbuilder/Direction";
import SortConfig from "views/logic/aggregationbuilder/SortConfig";
import Select from "components/common/Select";
const findOptionByLabel = (options, label) => options.find((option) => option.label === label);
const findOptionByValue = (options, value) => options.find((option) => option.value === value);
const currentValue = (sort, options) => {
  var _a;
  return sort && sort.length > 0 && ((_a = findOptionByLabel(options, sort[0].field)) == null ? void 0 : _a.value);
};
const sortedOptions = (fields) => fields.sort((field1, field2) => defaultCompare(field1.name, field2.name)).map((field, idx) => ({ label: field.name, value: idx })).toArray();
const onOptionChange = (options, onChange, value) => {
  const option = findOptionByValue(options, value);
  if (!option) {
    return void 0;
  }
  const sortConfig = new SortConfig(SortConfig.PIVOT_TYPE, option.label, Direction.Ascending);
  return onChange([sortConfig]);
};
const FieldSortSelect = ({ fields, onChange, sort }) => {
  const { t } = useTranslation("widgets");
  const options = useMemo(() => sortedOptions(fields), [fields]);
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: t("field_sort.placeholder"),
      onChange: (newValue) => onOptionChange(options, onChange, newValue),
      options,
      clearable: false,
      "aria-label": t("field_sort.aria_label"),
      value: currentValue(sort, options)
    }
  );
};
export default FieldSortSelect;
